var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Calendar',{attrs:{"mode":_vm.mode,"addButton":_vm.addButton,"dateStart":_vm.dateStart,"focusDate":_vm.focusDate,"reminderMapping":_vm.reminderMapping},on:{"add":function($event){return _vm.$emit('add')},"onfocus":(v) => _vm.$emit('onfocus', v),"updateDates":(v) => _vm.$emit('updateDates', v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }